import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MessageService, SelectItem } from 'primeng/api';
import { JobServicesService } from 'src/app/services/job-services.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { markAllControlsAsPristine } from 'src/app/shared/form.utils';

export enum UserTypes {
  superAdmin = 'Super Admin',
  admin = 'Admin',
  recruiter = 'Recruiter',
  evaluator = 'Evaluator',
  interviewer = 'Interviewer'
}

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.css'],
    providers: [MessageService],
    standalone: false
})

export class AddUserComponent implements OnChanges, OnInit {

  @Input() data: any;
  @Output() userAdded = new EventEmitter<any>();
  @Output() userUpdated = new EventEmitter<any>();
  associativeRoles: any = [];
  saveBtnLoading: boolean = false;
  showInfo: boolean = false;
  clicked: boolean = false;
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,24}$/;
  userPrivilages: any;
  userRole: string = '';
  userHeader: string = '';
  selectedRoleId!: string;
  dis !: any;
  infoData: any = [];
  addUserForm: FormGroup;
 
  edit: boolean = false;
  constructor(private jobServices: JobServicesService, private messageService: MessageService, private globalService: GlobalServicesService, private sharedService: SharedServicesService) {
    this.addUserForm = new FormGroup({
      first_name: new FormControl('', [Validators.required]),
      last_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
      mobile_number: new FormControl(null, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      role_id: new FormControl(null,[Validators.required]),
      is_sso_user: new FormControl(false),
      is_active: new FormControl(true)
    })
    this.getUserFormData();
  }

  ngOnChanges(): void {
    if (this.data) {
      this.data.isUpdate ? this.edit = true : this.edit = false;
      this.addUserForm.patchValue(this.data)
      if (typeof this.data.is_active !== 'undefined') {
        this.addUserForm.get('is_active')?.setValue(this.data.is_active);
      }
      
      if (this.data.isUpdate) {
        this.addUserForm.get('email')?.disable();
      } else {
        this.addUserForm.get('email')?.enable();
      }
    }
  }
  ngOnInit(): void {
    (this.data && this.data.isUpdate) ? this.userHeader = 'Update User': this.userHeader = 'Create New User';
    this.checkSSOProviders();
  }
  getUserFormData = () => {
    this.jobServices.getUserFormDataFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.infoData = [];
          this.associativeRoles = res.body.roles.map((item: any) => {
            this.infoData.push({ name: item.name, description: item.description, id: item.id });
            return { label: item.name, value: item.id }
          });
        }
      }
    });
  }

  saveUser = () => {
    this.clicked = true;    
    const fieldsToCheck = ['first_name', 'last_name', 'email', 'mobile_number'];
    if (this.sharedService.hasSecurityViolations(this.addUserForm, fieldsToCheck)) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.saveBtnLoading = false;
      return;
    }
    if (this.addUserForm.valid && this.addUserForm.dirty) {
      this.saveBtnLoading = true;
      if(this.data && this.data.isUpdate) {
        this.updateUser();
        return;
      }
      this.addUser();
    }
    if(!this.addUserForm.dirty) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'No Changes Detected', 
        detail: 'You haven\'t made any changes to the form. Please update at least one field before submitting.' 
      });
      return;
    }
    markAllControlsAsPristine(this.addUserForm);
  }
  public updateUser() {
    let payload = this.sharedService.getSecurePayload(this.addUserForm.value);
    if (this.data.isUpdate && this.addUserForm.get('email')?.disabled) {
      payload.email = this.data.email;
    }
    payload.is_active = this.addUserForm.value.is_active;
    this.jobServices.updateUserFastApi(payload, this.data.id).subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.addUserForm.reset();
          this.userUpdated.emit(res.body.detail); // Emit event to close dialog
        }
        this.saveBtnLoading = false;
        this.clicked = false;
      },
      error: (_err: any) => {
        this.saveBtnLoading = false;
        this.clicked = false;
      }
    });
  }
  public addUser() {
    let payload = this.sharedService.getSecurePayload(this.addUserForm.value);
    if (payload.email) {
      payload.email = payload.email.toLowerCase();
    }
    this.jobServices.createUserFastApi(payload).subscribe({
      next: (res: any) => {
        if (res.status === 201) {
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
          this.addUserForm.reset();
          this.userAdded.emit(res.body.detail);
        }
        this.saveBtnLoading = false;
        this.clicked = false;
      },
      error: (_err: any) => {
        this.saveBtnLoading = false;
        this.clicked = false;
      }
    });
  }

  onSave() { }

  cancel = () => {
    this.addUserForm.reset();
    this.showInfo = false;
    this.clicked = false;
  }
  onClick() {

    this.showInfo = true;
    this.selectedRoleId = this.addUserForm.value.role_id;
    for (let data of this.infoData) {
      if (data.id === this.selectedRoleId) {
        this.dis = data.description;
        break;
      }
    }
  }

  restrictNumber(event: any) {
    let e: any = event || window.event; 
    let key = e.keyCode || e.which;

    if (key < 48 || key > 57) { 
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
    }
  }

  checkSSOProviders() {
    const companyDetailsStr = localStorage.getItem('CompanyDetails');
    if (companyDetailsStr) {
      try {
        const companyDetails = JSON.parse(companyDetailsStr);
        const ssoProviders = companyDetails.sso_providers || [];
        
        if (ssoProviders.length >= 1 && !this.data?.isUpdate) {
          this.addUserForm.patchValue({
            is_sso_user: true
          });
        }
      } catch (error) {
        console.error('Error parsing company details:', error);
      }
    }
  }
}
